// extracted by mini-css-extract-plugin
module.exports = {"form":"departmentManagement_form__100cJ"};